import { render, staticRenderFns } from "./form-check.vue?vue&type=template&id=0bd87341&scoped=true"
import script from "./form-check.ts?vue&type=script&lang=ts&external"
export * from "./form-check.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd87341",
  null
  
)

export default component.exports